import { useEffect, useState } from 'react';
import { setAppState, subscribeAppState } from '../services/appstate-service';
import { clearSearch, getTypes, setCurrentType, setTextSearch, toggleFilterActive } from '../services/data-service';
import SearchInput from './searchInput';

import imgFS from '../images/fullscreen.svg';
import imgFSE from '../images/fullscreen_exit.svg';

import './header.scss';

const Header = ({ defaultType }) => {

    const [filtersOpen, setFiltersOpen] = useState(false);
    const [types, setTypes] = useState([]);
    const [typeSelected, setTypeSelected] = useState(null);
    const [fsOn, setFsOn] = useState(false);
    
    const toggleFilters = () => {
        setFiltersOpen(!filtersOpen);
    }
    
    useEffect(() => {
        setAppState({filtersOpen: filtersOpen});
    }, [filtersOpen]);
    
    useEffect(() => {

        setTypes(getTypes());

        if(defaultType) setTypeSelected(defaultType);

        const onAppState = (newState) => {
            setFiltersOpen(newState.filtersOpen);
        }

        const unsubscribeAppState = subscribeAppState(onAppState);
        return function cleanup() {
            unsubscribeAppState(onAppState);
        }
    }, [defaultType]);

    useEffect(()=>{

        if(types.length > 1){
            const urlparams = new URLSearchParams(window.top.location.search);
            const type = urlparams.get('type');
            if(type){
                setCurrentType(type);
                setTypeSelected(type);
            }
            const search = urlparams.get('search');
            if(search){
                setTextSearch({recherche: search.split(',')});
            }
        }

        const urlparams = new URLSearchParams(window.top.location.search);
        const filtersParam = urlparams.get('filters');
        const nextFilters = filtersParam ? filtersParam.split(',') : null;
        if(nextFilters && nextFilters.length){
            nextFilters.forEach(filterId => {
                toggleFilterActive(parseInt(filterId));
            });
        }
    }, [types]);

    const onInputChange = (event) => {
        clearSearch();
        setCurrentType(event.target.value);
        setTypeSelected(event.target.value);
    }

    const toggleFullScreen = (event) => {
        event.preventDefault();
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
            setFsOn(true);
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
            setFsOn(false);
          }
        }
    }

    return(
        <div className="data-map-header">
            <SearchInput />
            <div className="flex justify-content-between">
                <div className='flex'>
                    {types.length > 1 && <div className="flex radio-group">
                        {types.map(type => 
                            <label key={type.id}>
                                <input type="radio" value={type.id} name="types" checked={type.id === typeSelected} onChange={onInputChange} />
                                {type.label}
                            </label>
                        )}
                    </div>}
                    <button className={'input btn-filters' + (filtersOpen ? ' active' : '')} onClick={toggleFilters}>
                        <span className="label">Filtres</span>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                            <path d="M0 0h24v24H0z" fill="none"/>
                            <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"/>
                        </svg>
                    </button>
                </div>
                <div className='fs-toggler-container'>
                    <button onClick={(e) => toggleFullScreen(e)}>
                        {fsOn ? <img src={imgFSE} alt='toggle fullscreen' /> : <img src={imgFS} alt='toggle fullscreen' />}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Header;